/* The new header search's typed categories for the shopper's machine: its model's collections first, then only collections holding a part that fits it. */
(function () {
  'use strict';

  if (theme.searchMachineCategories) return;

  const CATEGORY_BLOCK = '.results--collections';
  const CATEGORY_LIST = '.results--collections ul';
  const OPTION_SELECTOR = 'li[role="option"]';
  const RESULTS = '.predictive-search-results';
  const FIRST_COLUMN = '.results__group-1';
  const INCOMPLETE_ATTR = 'data-search-incomplete';
  // search-fitment.js marks the products list before this runs when any candidate, shown or not, fits the machine.
  const FOUND_A_FIT = '.results--products [data-search-any-fit]';
  const NOTHING_KNOWN_TO_FIT = new Set();

  // Every list is cut to its limit, whatever is chosen: the ranked section renders all its candidates, the extras hidden.
  function prepare(search, section, searchTerm) {
    const lists = section.querySelectorAll(CATEGORY_LIST);
    if (!lists.length) return;
    const choice = machineChoice(search, section, searchTerm);
    lists.forEach((list) => arrange(list, choice));
    dropEmpty(section);
  }

  // From what has arrived, so no search waits on these lookups. A search with no part for the machine is about something else
  // (an H2 exhaust from a CF Moto owner) and keeps Shopify's categories (null); without the machine's list yet, only its model's show.
  function machineChoice(search, section, searchTerm) {
    const machine = activeMachine();
    const models = theme.searchModelCollections;
    const terms = models ? models.wordsOf(searchTerm) : [];
    if (!machine || !terms.length || !theme.searchMachineFits || !section.querySelector(FOUND_A_FIT)) return null;
    const entries = models.ready(search.dataset.modelCollectionsUrl);
    const fits = theme.searchMachineFits.ready(search.dataset.machineFitsUrl, machine.id);
    if (!entries || !fits) missing(search, section, machine);
    const leading = entries ? models.rowsFor(entries, machine.name, terms) : [];
    // Never down to an empty panel: with nothing else to show, categories stay as Shopify ranked them.
    return { leading, keep: hasOtherResults(section) ? fits || NOTHING_KNOWN_TO_FIT : null };
  }

  // A machine picked since search opened has no lists yet: fetch them for the next search, and keep these results out of the cache.
  function missing(search, section, machine) {
    const results = section.querySelector(RESULTS);
    if (results) results.setAttribute(INCOMPLETE_ATTR, '');
    Promise.all([
      theme.searchModelCollections.load(search.dataset.modelCollectionsUrl),
      theme.searchMachineFits.load(search.dataset.machineFitsUrl, machine.id),
    ]).catch(() => {});
  }

  // The model's collections first, then the others known to hold a part for the machine, once each, within the list's limit; with
  // no choice, the candidates in Shopify's order. Those that make the cut show.
  function arrange(list, choice) {
    const limit = parseInt(list.getAttribute('data-visible-limit'), 10) || list.children.length;
    const lead = choice ? choice.leading.map((row) => row.cloneNode(true)) : [];
    const handles = new Set(lead.map(handleOf));
    const keep = choice && choice.keep;
    const rest = Array.from(list.children).filter((row) => !handles.has(handleOf(row)) && (!keep || keep.has(handleOf(row))));
    const shown = lead.concat(rest).slice(0, limit);
    shown.forEach((row) => row.removeAttribute('hidden'));
    list.replaceChildren(...shown);
  }

  // A categories block left with none goes, and so does a first column left with nothing, as Liquid hides an empty one.
  function dropEmpty(section) {
    section.querySelectorAll(CATEGORY_BLOCK).forEach((block) => { if (!block.querySelector(OPTION_SELECTOR)) block.remove(); });
    section.querySelectorAll(FIRST_COLUMN).forEach((column) => { if (!column.children.length) column.remove(); });
  }

  function hasOtherResults(section) {
    return Array.from(section.querySelectorAll(OPTION_SELECTOR)).some((option) => !option.closest(CATEGORY_BLOCK));
  }

  function handleOf(row) {
    return theme.searchOverlayParts.collectionHandle(row);
  }

  // search-fitment.js's machine in either arm of the fitment test: none while it's switched off or a shared link's is looked up.
  function activeMachine() {
    const fitment = theme.searchFitment;
    const status = fitment && fitment.machineStatus ? fitment.machineStatus() : null;
    return status && status.machine && status.machine.id ? status.machine : null;
  }

  theme.searchMachineCategories = { prepare };
})();
